import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-dm-responses',
		path: '/admin/p/:slug/dm_responses',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-petition-dmResponses" */ './index'), {
			exportName: 'DmResponses',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
